import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'
import { attendanceStatus, requiredString, userStatus } from '@/utils/zod'

import type { Attendance } from '../types'

const responseSchema = z.array(
  z.object({
    id: requiredString(),
    presence: attendanceStatus,
    student: z.object({
      id: requiredString(),
      name: requiredString(),
      first_name: requiredString(),
      last_name: requiredString(),
      status: userStatus
    })
  })
)

const parseResponse = (
  response: z.infer<typeof responseSchema>
): Attendance[] =>
  response.map(item => ({
    id: item.id,
    presence: item.presence ? item.presence : null,
    student: {
      id: item.student.id,
      name: item.student.name,
      firstName: item.student.first_name,
      lastName: item.student.last_name,
      status: item.student.status
    }
  }))

const useAttendanceList = (lessonId: string) =>
  useQuery({
    queryKey: ['panelAttendancesList', lessonId],
    staleTime: 60 * 100,
    queryFn: async () => {
      const response = await httpService.panel.panelAttendancesList({
        page_size: 'max',
        lesson_id: lessonId,
        ordering: 'last_name,first_name',
        fetchKeys: {
          id: true,
          presence: true,
          student: true
        }
      })

      return parseResponse(responseSchema.parse(response.results))
    },
    enabled: !!lessonId
  })

export default useAttendanceList
